// ============================================================
// toast.js — Notificaciones ligeras
// ============================================================
import { qs, el } from './utils.js';
import { showSubscriptionModal } from './subscriptionModal.js';

const ICONS = {
  success: 'bi-check-circle-fill',
  error:   'bi-exclamation-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info:    'bi-info-circle-fill',
};

export function toast({ message, type = 'info', duration = 3000 }) {
  if (!message) return;

  const msgLower = String(message).toLowerCase();
  if (
    type === 'error' &&
    (msgLower.includes('prueba gratuito') ||
     msgLower.includes('trial') ||
     msgLower.includes('suscripción') ||
     msgLower.includes('suscripcion') ||
     msgLower.includes('período de prueba') ||
     msgLower.includes('periodo de prueba') ||
     msgLower.includes('límite de gasto') ||
     msgLower.includes('limite de gasto') ||
     msgLower.includes('activar tu'))
  ) {
    showSubscriptionModal({
      title: '¡Activa tu Período de Prueba!',
      message: String(message).replace(/^Error al [^:]+:\s*/i, ''),
      redirectUrl: 'precios.html',
    });
    return;
  }

  let container = qs('#toastContainer');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toastContainer';
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const icon = ICONS[type] || ICONS.info;
  const item = el(`
    <div class="toast-item is-${type}" role="status">
      <i class="bi ${icon}"></i>
      <span></span>
    </div>
  `);
  // Insertamos el mensaje como text para evitar inyección
  item.querySelector('span').textContent = message;

  container.appendChild(item);

  setTimeout(() => {
    item.style.opacity = '0';
    item.style.transition = 'opacity 200ms';
    setTimeout(() => item.remove(), 220);
  }, duration);
}
